'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MessageInfo = require('./MessageInfo');

var _MessageInfo2 = _interopRequireDefault(_MessageInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        MessageInfo: _MessageInfo2.default
    },
    props: ['ml', 'message', 'idx'],
    data: function data() {
        return {};
    },

    computed: {
        displayNick: function displayNick() {
            var prefix = this.message.user ? this.userModePrefix(this.message.user) : '';

            var suffix = this.message.nick ? ':' : '';

            return prefix + this.message.nick + suffix;
        },
        userColour: function userColour() {
            return this.ml.userColour(this.message.user);
        }
    },
    methods: {
        userModePrefix: function userModePrefix(user) {
            return this.ml.buffer.userModePrefix(user);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageListMessageInline.vue
// module id = wy/0
// module chunks = 1